import { Navigate, useLocation } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { Loader2 } from "lucide-react";

export default function ProtectedAdminRoute({ children }) {
  const { admin, checking } = useAuth();
  const location = useLocation();

  if (checking) {
    return (
      <div className="min-h-[60vh] flex items-center justify-center text-[#5F6B62]" data-testid="admin-loading">
        <Loader2 size={18} className="animate-spin mr-2" /> Checking session…
      </div>
    );
  }
  if (!admin) {
    return <Navigate to="/admin/login" state={{ from: location.pathname }} replace />;
  }
  return children;
}
